var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoteTickIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#0C2012",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6354 21.6666C45.2605 21.6868 47.2236 21.8476 48.5043 23.1282C49.9687 24.5927 49.9687 26.9497 49.9687 31.6637V41.6637C49.9687 46.3778 49.9687 48.7348 48.5043 50.1993C47.0398 51.6637 44.6828 51.6637 39.9687 51.6637H29.9687C25.2547 51.6637 22.8977 51.6637 21.4332 50.1993C19.9688 48.7348 19.9688 46.3778 19.9688 41.6637V31.6637C19.9688 26.9497 19.9688 24.5927 21.4332 23.1282C22.7139 21.8476 24.677 21.6868 28.3021 21.6666",
    stroke: "#0C2012",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9688 37.3334L32.8259 40L39.9688 33.3334",
    stroke: "#0C2012",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3008 20.8334C28.3008 19.4527 29.4201 18.3334 30.8008 18.3334H39.1341C40.5148 18.3334 41.6341 19.4527 41.6341 20.8334V22.5C41.6341 23.8808 40.5148 25 39.1341 25H30.8008C29.4201 25 28.3008 23.8808 28.3008 22.5V20.8334Z",
    stroke: "#0C2012",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteTickIcon);
export default __webpack_public_path__ + "static/media/NoteTickIcon.5725649fcedc40809fd90455fbb8eb5f.svg";
export { ForwardRef as ReactComponent };